import axios from "axios";

const BASE_URL = (process.env.REACT_APP_LSP_BASE_URL || "").replace(/\/+$/, "") + "/";

function errMsg(e) {
    const data = e?.response?.data;
    if (typeof data === "string") return data;
    if (data?.message) return data.message;
    return e?.message || "Unknown error";
}

export async function getToken(username, password) {
    // POST {BASE_URL}/get-token/ :contentReference[oaicite:2]{index=2}
    try {
        const res = await axios.post(`${BASE_URL}get-token/`, { username, password });
        return res.data; // {success, token}
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function createLoan(token, body) {
    // POST {BASE_URL}/LSPLoan/create-loan/ :contentReference[oaicite:3]{index=3}
    try {
        const res = await axios.post(`${BASE_URL}LSPLoan/create-loan/`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function getLoanStatus(token, partnerLoanId) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/loan-status/ :contentReference[oaicite:4]{index=4}
    try {
        const res = await axios.get(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/loan-status/`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function getRepaymentSchedule(token, partnerLoanId, startDate) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/get-repayment-schedule/?start_date=... :contentReference[oaicite:5]{index=5}
    try {
        const res = await axios.get(
            `${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/get-repayment-schedule/`,
            {
                headers: { Authorization: `Bearer ${token}` },
                params: { start_date: startDate },
            }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function initiateNach(token, partnerLoanId, body) {
    // POST {BASE_URL}/LSPLoan/{partner_loan_id}/initiate-nach/ :contentReference[oaicite:6]{index=6}
    try {
        const res = await axios.post(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/initiate-nach/`, body, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function createAgreement(token, partnerLoanId) {
    // POST {BASE_URL}/LSPLoan/{partner_loan_id}/create-agreement/ :contentReference[oaicite:7]{index=7}
    try {
        const res = await axios.post(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/create-agreement/`, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function loanDetails(token, partnerLoanId) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/loan-details/ :contentReference[oaicite:8]{index=8}
    try {
        const res = await axios.get(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/loan-details/`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function uploadDocuments(token, partnerLoanId, docType, file) {
    // POST {BASE_URL}/LSPLoan/{partner_loan_id}/upload-documents/ (multipart) :contentReference[oaicite:9]{index=9}
    try {
        const fd = new FormData();
        fd.append("doc_type", docType);
        fd.append("file", file);

        const res = await axios.post(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/upload-documents/`, fd, {
            headers: {
                Authorization: `Bearer ${token}`,
                // DO NOT set content-type manually; browser will set boundary
            },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function retrieveDocuments(token, partnerLoanId) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/retrieve-documents/ :contentReference[oaicite:10]{index=10}
    try {
        const res = await axios.get(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/retrieve-documents/`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function viewAgreement(token, partnerLoanId) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/view-agreement/ :contentReference[oaicite:11]{index=11}
    try {
        const res = await axios.get(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/view-agreement/`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data; // string URL
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function initiateUpiPayment(token, partnerLoanId, amount) {
    // POST {BASE_URL}/LSPLoan/{partner_loan_id}/initiate-upi-payment/ :contentReference[oaicite:12]{index=12}
    try {
        const res = await axios.post(
            `${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/initiate-upi-payment/`,
            { amount },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function getPayments(token, partnerLoanId, paymentIdOptional) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/get-payment/?payment_id=... :contentReference[oaicite:13]{index=13}
    try {
        const res = await axios.get(`${BASE_URL}LSPLoan/${encodeURIComponent(partnerLoanId)}/get-payment/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: paymentIdOptional ? { payment_id: paymentIdOptional } : {},
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}
